module.exports = __webpack_public_path__ + "assets/images/project/people/baby.svg?v=768ba5bd";